import { render } from "./MobileTutorial.vue?vue&type=template&id=38709559"
import script from "./MobileTutorial.vue?vue&type=script&lang=js"
export * from "./MobileTutorial.vue?vue&type=script&lang=js"

import "./MobileTutorial.vue?vue&type=style&index=0&id=38709559&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__